import OutflowGrid from "@/components/OutflowGrid";

export default function DevelopmentCost() {
  return (
    <OutflowGrid
      page="development"
      testId="outflows-development"
      kicker="Outflows"
      title="Development Cost"
      editRole="liaisoning"
      description="Land Owner Payments per JDA / land parcel + Development Cost. Amounts in ₹ Lakhs."
    />
  );
}
